// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n9oh","label":"styles_label__2H578"};